import { render } from "./PageUpdateHasilWawancaraPsikologi.vue?vue&type=template&id=80cd7b56"
import script from "./PageUpdateHasilWawancaraPsikologi.vue?vue&type=script&lang=js"
export * from "./PageUpdateHasilWawancaraPsikologi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__